import { useQuery } from '@tanstack/react-query';

import { getAtolCertificateById } from '~/services/TravelComplianceService';

import { atolCertificateQueryKeys } from './atolCertificateQueryKeys';

export function useGetAtolCertificateById(id: string) {
  return useQuery({
    queryKey: atolCertificateQueryKeys.detail(id),
    queryFn: async () => {
      const response = await getAtolCertificateById(id);
      return response.result;
    },
    enabled: !!id,
  });
}
